'use client'

import { useState, useRef } from 'react'

interface Ripple {
  x: number
  y: number
  id: number
}

export default function AnimatedBody({ children }: { children: React.ReactNode }) {
  const [ripples, setRipples] = useState<Ripple[]>([])
  const rippleIdCounter = useRef(0)

  const handleClick = (e: React.MouseEvent<HTMLBodyElement>) => {
    const newRipple: Ripple = {
      x: e.clientX,
      y: e.clientY,
      id: rippleIdCounter.current++,
    }

    setRipples((prev) => [...prev, newRipple])

    // Remove ripple after animation completes
    setTimeout(() => {
      setRipples((prev) => prev.filter((ripple) => ripple.id !== newRipple.id))
    }, 1000)
  }

  return (
    <body
      className="bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950 min-h-screen relative overflow-x-hidden"
      onClick={handleClick}
    >
      {children}

      {/* Render ripples */}
      {ripples.map((ripple) => (
        <div
          key={ripple.id}
          className="pointer-events-none fixed animate-ping"
          style={{
            left: ripple.x,
            top: ripple.y,
            width: '20px',
            height: '20px',
            marginLeft: '-10px',
            marginTop: '-10px',
          }}
        >
          <div className="w-full h-full rounded-full bg-blue-400/30 blur-sm" />
        </div>
      ))}
    </body>
  )
}
